import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import TopBar from '../components/molecules/TopBar';
import TopBarBackButton from '../components/atoms/TopBarBackButton';
import { ConnectionState, resetUserDb } from '../services/DBService/DbService';
import { StateProperty, Userdata } from '@app/common';
import { setConnectionState, _devResetUser, _devSetUser } from '../store/globalStateSlice';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import PrimaryButton from 'src/components/atoms/PrimaryButton';
import { clearStoredLogin, getStoredUsername } from 'src/services/AuthStorageService';

const Settings = () => {
    const navigate = useNavigate();

    const stateProperties = useAppSelector(state => state.globalState.user?.stateProperties || []);
    const user = useAppSelector(state => state.globalState.user);

    const dispatch = useAppDispatch();

    const [phase, setPhase] = React.useState<StateProperty>(stateProperties.includes('PREGNANCY') ? 'PREGNANCY' : 'POSTPARTUM');

    const phaseChanged = (ev: any) => {
        setPhase(ev.target.value);
    };

    if (!user) {
        return <></>;
    }

    const resetUserClicked = () => {
        if (!window.confirm('Alle Daten des Benutzers werden zurückgesetzt. Bitte wiederholen Sie diese Aktion bis zu 3 mal, um sicherzugehen, dass wriklich alle Daten gelöscht sind.')) {
            return;
        }
        resetUserDb();

        const resettedUser: Userdata = {
            ...user,
            userProperties: user.userProperties,
            stateProperties: [ 'PREGNANCY' ],
            coachId: undefined,
            variables: {}
        };
        dispatch(_devResetUser(resettedUser));
    };

    const saveSettings = () => {
        if (user) {
            const newUser: Userdata = JSON.parse(JSON.stringify(user));
            newUser.stateProperties = [
                ...newUser.stateProperties.filter(p => ['POSTPARTUM', 'PREGNANCY'].includes(p) === false),
                phase
            ];
            dispatch(_devSetUser(newUser));

            alert('Phase wurde gespeichert.');
        }
    };

    const logout = () => {
        if (user) {
            clearStoredLogin();
            dispatch(_devSetUser(undefined));
            dispatch(setConnectionState(ConnectionState.DISCONNECTED));
            // setTimeout(() => navigate('/'), 3000);
        } else {
            console.log('no userobject');
        }
    };

    return (
        <div className="content">
            <TopBar
                title="Dev-Settings"
                leftButtons={[<TopBarBackButton onClick={() => navigate('../settings')} />]}
            />
            <div className="content-container">
                <div>Angemeldet als: {getStoredUsername()}</div>
                <PrimaryButton onClick={logout} label="Abmelden" />
                <hr/>
                Phase
                <select onChange={phaseChanged} defaultValue={phase}>
                    <option value="PREGNANCY">Schwangerschaft</option>
                    <option value="POSTPARTUM">Post Partum</option>
                    <optgroup label="" />
                </select>
                <PrimaryButton onClick={() => saveSettings()} label="Speichern" />
                <hr/>
                <div>
                    <PrimaryButton onClick={resetUserClicked} label="Benutzer zurücksetzen" />
                </div>
            </div>
            <div className="menu-bot" />
        </div>
    );
};
export default Settings;